// 文档：https://cloud.tencent.com/document/product/460/6929

// 是否是万象优图的url
function isCloudImage(src) {
  return src.indexOf('.image.myqcloud.com') > 0
}

function setCloudImageView(src, options = {}) {
  if (!isCloudImage(src)) {
    return src
  }
  const ipos = src.indexOf('//')
  if (ipos !== -1) {
    src = src.substring(ipos, src.length)
  }
  let query = '?imageView2'

  /* eslint-disable no-restricted-syntax */
  for (const [key, value] of Object.entries(options)) {
    query += `/${key}/${value}`
  }
  return src + query
}

const imgUrlFormat = (src, options = {}) => {
  const defaultOptions = { q: 50 }
  if (!src) return ''
  return setCloudImageView(src, Object.assign({}, defaultOptions, options))
}

export default imgUrlFormat

